var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[_c('p',{class:{'text-danger': _vm.total<=0}}),_c('strong',[_vm._v(_vm._s(_vm.hours))]),_c('strong',[_vm._v(":")]),_c('strong',[_vm._v(_vm._s(_vm.minutes))]),_c('strong',[_vm._v(":")]),_c('strong',[_vm._v(_vm._s(_vm.seconds))]),_c('p')])
}
var staticRenderFns = []

export { render, staticRenderFns }